module.exports = __webpack_public_path__ + "static/img/product06-1.8fa7c44c.png";